import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, FormGroup } from "@angular/forms";

interface ICheckBoxItem {
  value: string;
  item: any;
  checked: boolean;
  disabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CheckboxHelperService {

  constructor(private fb: UntypedFormBuilder) {
  }

  public createControls(form: AbstractControl, formArrayPath: string, values: {}): UntypedFormArray {
    const formArray = form.get(formArrayPath) as UntypedFormArray;
    this.toCheckboxes(values).forEach((control) => {
      formArray.push(control);
    });
    return formArray;
  }

  public patchValue(form: AbstractControl, formArrayPath: string, values: string[]): void {
    const formValues = form.get(formArrayPath).value as ICheckBoxItem[];
    form.get(formArrayPath).patchValue(formValues.map((i) => {
      if (values.includes(i.value)) {
        i.checked = true;
      }
      return i;
    }));
  }

  public patchDisable(form: AbstractControl, formArrayPath: string, values: string[]): void {
    const formValues = form.get(formArrayPath).value as ICheckBoxItem[];
    form.get(formArrayPath).patchValue(formValues.map((i) => {
      if (values.includes(i.value)) {
        i.disabled = true;
      }
      return i;
    }));
  }

  public getValue(form: AbstractControl, formArrayPath: string): string[] {
    const formArray = form.get(formArrayPath) as UntypedFormArray;
    const values = [];
    formArray.value.forEach((i) => {
      if (i.checked) {
        values.push(i.value);
      }
    });
    return values;
  }

  public toCheckboxes(data: {}): UntypedFormControl[] {
    if (typeof data === 'undefined' || data === null){
      return [];
    }
    const array = [];
    Object.keys(data).forEach((key) => {
      array.push(this.fb.group({
        value: key,
        item: data[key],
        checked: false,
        disabled: false,
      }));
    });
    return array;
  }

}
